import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { DataService } from "src/app/services/data.service";
import { buildSEOImageUrl } from "src/app/utils/seo-image.helper";

@Component({
  selector: "app-downloads",
  templateUrl: "./downloads.component.html",
  styleUrls: ["./downloads.component.scss"],
})
export class DownloadsComponent implements OnInit {
  downloadData: any = [];
  user: any;
  isPremium: boolean = false;
  loader = true;
  imageLoad = false;
  skeletonArray = Array(20); // number of skeleton rows

  visibleDownloads: any[] = [];    // data shown in table
  pageSize = 20;
  currentPage = 1;
  isLoadingMore = false;
  @ViewChild("licenseModalModal") licenseModalModal: ElementRef;
  constructor(private _snackBar: MatSnackBar, private dataService: DataService, private title: Title, private router: Router) { }

  getSEOImage(url: string): string {
    return buildSEOImageUrl(url);
  }

  async ngOnInit() {
    this.user = this.dataService.userDetail;
    if (!this.user || !this.user.id) {
      this.router.navigate(["/"]);
      return;
    }
    this.title.setTitle(`Downloads | Illusbook`);
    (await this.dataService.getdownloadHistoryByIDService(this.user.id)).subscribe(
      (singleservice) => {
        this.downloadData = singleservice || [];
        this.loader = false;
        this.initLoad();
        //console.log(singleservice);

      }, () => {
        this.loader = false;
      }
    );
  }

  copyAttribution(event: Event): void {
    event.preventDefault();

    const attribution = `<a href="https://illusbook.com/" target="_blank" rel="noopener noreferrer">Designed by Illusbook</a>`;

    if (navigator.clipboard) {
      navigator.clipboard.writeText(attribution).then(() => {
        this._snackBar.open("Attribution copied to clipboard!", "Okay", { duration: 1000 });
      }).catch(err => {
        console.error('Failed to copy!', err);
      });
    } else {
      console.warn("Clipboard API not supported");
    }
  }


  /* initial load */
  initLoad() {
    this.currentPage = 1;
    this.visibleDownloads = this.downloadData.slice(0, this.pageSize);
  }

  /* load more */
  loadMore() {
    this.isLoadingMore = true;

  setTimeout(() => {   // UX delay simulation (optional)
    this.currentPage++;

    const nextData = this.downloadData.slice(
      0,
      this.currentPage * this.pageSize
    );

    this.visibleDownloads = nextData;
    this.isLoadingMore = false;
  }, 300); // 300ms feels natural
  }

  /* button visibility */
  get hasMoreData(): boolean {
    return this.visibleDownloads.length < this.downloadData.length;
  }
}
